"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-1601474a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, null, -1));
const _hoisted_3 = {
    key: 0,
    class: "flex gap-0 justify-end items-center bg-gray w-28 h-10 mr-0 ml-auto relative"
};
const _hoisted_4 = ["id", "disabled"];
const _hoisted_5 = ["for"];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-shopping_cart add-to-cart" }, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 0,
    class: "absolute text-white text-base bg-black p-1 rounded z-10 leading-none -right-2 font-bold"
};
const _hoisted_10 = {
    key: 1,
    class: "absolute text-white text-base bg-gray-darker p-1 rounded z-20 leading-none -right-2 font-bold"
};
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "inline-flex gap-0 grid-cols-3 justify-end items-center bg-gray h-10 mr-0 ml-auto float-right relative" };
const _hoisted_13 = ["id", "disabled"];
const _hoisted_14 = ["for"];
const _hoisted_15 = ["data-hover", "disabled"];
const _hoisted_16 = {
    key: 0,
    class: "icon marso-icon-wheel-3d"
};
const _hoisted_17 = {
    key: 1,
    class: "icon marso-icon-shopping_cart"
};
const _hoisted_18 = {
    key: 0,
    class: "absolute text-white text-base bg-black p-1 rounded z-10 leading-none -right-2 font-bold"
};
const _hoisted_19 = {
    key: 1,
    class: "absolute text-white text-base bg-gray-darker p-1 rounded z-20 leading-none -right-2 font-bold"
};
const _hoisted_20 = ["data-hover", "disabled"];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-xl" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-screw-nut-3d" })
], -1));
const _hoisted_22 = [
    _hoisted_21
];
const vue_3 = require("vue");
const tagStore_1 = require("../../../stores/tag/tagStore");
const cartsStore_1 = require("../../../stores/carts/cartsStore");
const toastStore_1 = require("../../../stores/toast/toastStore");
const i18n_1 = require("../../../common/i18n");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartCell',
    props: {
        product: null
    },
    setup(__props) {
        const props = __props;
        const tagStore = (0, tagStore_1.useTagStore)();
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const isCartButtonDisabled = (0, vue_3.computed)(() => {
            if (props.product.stocks.stockCentral && props.product.stocks.stockCentral > 0) {
                return false;
            }
            if (props.product.stocks.stockCountry && props.product.stocks.stockCountry > 0) {
                return false;
            }
            if (props.product.stocks.stockExpress && props.product.stocks.stockExpress > 0) {
                return false;
            }
            if (props.product.stocks.stockLocal && props.product.stocks.stockLocal > 0) {
                return false;
            }
            if (props.product.stocks.stockManufacturer && props.product.stocks.stockManufacturer > 0) {
                return false;
            }
            if (props.product.stocks.stockHun && props.product.stocks.stockHun > 0) {
                return false;
            }
            if (props.product.stocks.status === 'orderable') {
                return false;
            }
            return true;
        });
        const priceOptionsProductQuantity = (0, vue_3.computed)(() => {
            if (!cartsStore.activeCart)
                return 0;
            // price option id prefix
            const baseIdPrefix = `${props.product.id}@`;
            const relatedItems = cartsStore.activeCart.products.filter((product) => {
                const hasPriceOption = product.priceOptionCode !== '';
                if (!hasPriceOption)
                    return false;
                // Megnézzük, hogy az adott termékhez tartozik-e a price option.
                const belongsToThisProduct = product.id.startsWith(baseIdPrefix);
                return belongsToThisProduct;
            });
            const totalQuantity = relatedItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
            return totalQuantity;
        });
        const isHoveringKitset = (0, vue_3.ref)(false);
        const addToCart = async (productId, kitsetId, product) => {
            if (productId === undefined) {
                return;
            }
            let inputId = 'quantity-' + productId;
            let input = document.getElementById(inputId);
            let quantity = 0;
            if (input instanceof HTMLInputElement) {
                quantity = parseInt(input.value ? input.value : "0");
            }
            let kitsetQuantity = 0;
            if (0 < quantity) {
                kitsetQuantity = 1;
            }
            try {
                await cartsStore.addProduct(router, quantity, productId);
                if (input instanceof HTMLInputElement) {
                    input.value = "";
                }
                if (kitsetId && kitsetQuantity) {
                    await cartsStore.addProduct(router, kitsetQuantity, kitsetId);
                }
                if (quantity === 0) {
                    return;
                }
                if (!product) {
                    return;
                }
                const { prices } = product;
                const totalValue = quantity * prices.priceNet;
                const gtagData = {
                    currency: prices.currencyCode,
                    value: totalValue,
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.productName,
                            price: prices.priceNet,
                            quantity: quantity,
                        },
                    ],
                };
                gtag("event", "add_to_cart", gtagData);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            var _a, _b;
            return ((0, vue_2.unref)(tagStore).tags.columns.cartColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `cart-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    _hoisted_2,
                    (__props.product.active && __props.product.type !== 'rim')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("input", {
                                id: 'quantity-' + __props.product.id,
                                class: "quantity h-full text-center aspect-square block w-10 bg-gray",
                                type: "number",
                                min: "0",
                                max: "100",
                                placeholder: "0",
                                disabled: (0, vue_2.unref)(isCartButtonDisabled),
                                onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                            }, null, 8, _hoisted_4),
                            (0, vue_2.createElementVNode)("label", {
                                for: 'quantity-' + __props.product.id,
                                class: "flex pr-1 items-center justify-center h-full font-bold text-center w-10",
                                onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('short_unit', 'pc.', 'cart_cell')), 9, _hoisted_5),
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                class: (0, vue_2.normalizeClass)(["aspect-square add-to-cart btn btn-primary btn-cart relative", (0, vue_2.unref)(isCartButtonDisabled) ? 'border-transparent text-white bg-gray-darkest' : '']),
                                disabled: (0, vue_2.unref)(isCartButtonDisabled),
                                onClick: _cache[2] || (_cache[2] = ($event) => (addToCart(__props.product.id, undefined, __props.product)))
                            }, _hoisted_8, 10, _hoisted_6),
                            ((0, vue_2.unref)(cartsStore).activeCart && 0 < (0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("sup", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id)), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(cartsStore).activeCart && 0 < (0, vue_2.unref)(priceOptionsProductQuantity))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("sub", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id) > 0 ? '+' : '') + (0, vue_2.toDisplayString)((0, vue_2.unref)(priceOptionsProductQuantity)), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.product.active && __props.product.type === 'rim')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createElementVNode)("input", {
                                    id: 'quantity-' + __props.product.id,
                                    class: "quantity h-full text-center aspect-square w-12 pl-1 bg-gray",
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    placeholder: "0",
                                    disabled: (0, vue_2.unref)(isCartButtonDisabled),
                                    onClick: _cache[3] || (_cache[3] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                }, null, 8, _hoisted_13),
                                (0, vue_2.createElementVNode)("label", {
                                    for: 'quantity-' + __props.product.id,
                                    class: "flex items-center justify-center h-full font-bold text-center px-1",
                                    onClick: _cache[4] || (_cache[4] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('short_unit', 'pc.', 'cart_cell')), 9, _hoisted_14),
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: (0, vue_2.normalizeClass)(["add-to-cart show-hover aspect-square btn btn-primary btn-cart relative", [
                                            (0, vue_2.unref)(isCartButtonDisabled) ? 'border-transparent text-white bg-gray-darkest' : '',
                                            isHoveringKitset.value ? '!bg-blue-dark !border-blue-dark' : ''
                                        ]]),
                                    "data-hover": (0, vue_2.unref)(i18n_1.trans)('rim_only', 'Rim only', 'cart_cell'),
                                    disabled: (0, vue_2.unref)(isCartButtonDisabled),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (addToCart(__props.product.id, undefined, __props.product)))
                                }, [
                                    ((_a = __props.product.kitsetProduct) === null || _a === void 0 ? void 0 : _a.id)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_16))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_17))
                                ], 10, _hoisted_15),
                                ((0, vue_2.unref)(cartsStore).activeCart && 0 < (0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("sup", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id)), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(cartsStore).activeCart && 0 < (0, vue_2.unref)(priceOptionsProductQuantity))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("sub", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(cartsStore).activeCart.getSizeByProduct(__props.product.id) > 0 ? '+' : '') + (0, vue_2.toDisplayString)((0, vue_2.unref)(priceOptionsProductQuantity)), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((_b = __props.product.kitsetProduct) === null || _b === void 0 ? void 0 : _b.id)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 2,
                                        type: "button",
                                        class: (0, vue_2.normalizeClass)(["relative add-to-cart-with-kitset show-hover btn btn-cart btn-info hover:btn-primary hover:!border-blue-dark aspect-square", (0, vue_2.unref)(isCartButtonDisabled) ? 'border-transparent text-white bg-gray-darkest' : '']),
                                        "data-hover": (0, vue_2.unref)(i18n_1.trans)('rim_and_kitset', 'Rim + Kitset', 'cart_cell'),
                                        disabled: (0, vue_2.unref)(isCartButtonDisabled),
                                        onClick: _cache[6] || (_cache[6] = ($event) => (addToCart(__props.product.id, __props.product.kitsetProduct.id, __props.product))),
                                        onMouseover: _cache[7] || (_cache[7] = ($event) => (isHoveringKitset.value = true)),
                                        onMouseleave: _cache[8] || (_cache[8] = ($event) => (isHoveringKitset.value = false))
                                    }, _hoisted_22, 42, _hoisted_20))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
